import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as realGamesService from "../services/realGamesService"
import * as utilService from "../services/utilService"
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID, deckHerosAdminUrl } from '../configs/const';
import Header from './header'
import Menu from './menu'
import * as authUtil from "../util/auth.util";

let socket = null
let oid = OPERATOR_ID.toLowerCase()
class RealGames extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            url: "",
            isCasinoFull: true,
            loader: false
        };
    }
    logout() {
        let appType = localStorage.getItem("appType")
        let rememberData = localStorage.getItem("rememberData")
        localStorage.clear()
        localStorage.setItem("rememberData", rememberData)
        sessionStorage.removeItem('demoIdSsData');
        sessionStorage.removeItem('demoExpo');
        sessionStorage.removeItem('demoPnL');
        if (appType === "mobile") {
            window.location.href = window.location.origin + "/apk";
        } else {
            window.location.href = window.location.origin + "/auth";
        }
        
    }
    async componentDidMount() {
        document.getElementsByTagName('html')[0].classList.add('iframe-container-page')
        let userData = localStorage.getItem("tokenData")
        userData = JSON.parse(userData)
        if (!(!!userData && !!userData.sub)) {
            authUtil.logout();
        }
        if (!!userData && userData.role !== 'DemoClient') {
        socket = this.props.socket
        if (this.props.updateSocket) {
            this.props.updateSocket(socket)
        }

        let self = this;
        this.setState({ loader: true });

        setTimeout(() => {
            // this.props.subscribe('user_room', userData.sub)
            // this.props.subscribe('site_room', userData.sub)
            if (!!this.props.subscriptions && this.props.subscriptions.user_room.indexOf(userData.sub) === -1) {
                socket.emit('user_room', userData.sub)
                this.props.subscribe('user_room', userData.sub)
                // Sentry.captureMessage(' Socket Connected :- ' + userData.sub )
            }
            socket.on("user_room", data => {
                let msg = JSON.parse(data)
                if (!!msg.command && msg.command === "LOGOUT") {
                    authUtil.logout();
                }
            })
            if (!!this.props.subscriptions && this.props.subscriptions.site_room.indexOf(userData.sub) === -1) {
                socket.emit('site_room', userData.sub)
                this.props.subscribe('site_room', userData.sub)
            }
            this.props.socket.on('site_room', (data) => {
                let msg = JSON.parse(data)
                if (!!msg.command && msg.command === "LOGOUT") {
                    authUtil.logout();
                }
            })
        }, 1000);
        // realGamesService.getToken().then((res) => {
        //     if (res.status === 200) {
        //         let id = res.data.id
        //         let url = deckHerosAdminUrl + "/launch/" + id
        //         this.setState({ url: url })
        //         setTimeout(() => {
        //             self.setState({ loader: false })
        //         }, 2000);
        //     }
        // })
        let ipData = await utilService.getClientIPOwnApi;//.getClientIp()

        let body = {
            "operatorPlayerId": OPERATOR_ID + ":" + userData.sub,
            "deviceType": this.getDeviceType(),
            "role": "Client",
            "clientIp": ipData.ip
        }
        body = this.clean(body);
        
            realGamesService.getRealGamesLaunchUrl(body).then((res) => {
                if (!!res.url) {
                    let cgurl = res.url;
                    cgurl = cgurl + '&from=' + window.location.host.substring(4);
                    this.setState({ url: cgurl })
                    setTimeout(() => {
                        self.setState({ loader: false })
                    }, 2000);
                }
            })
        
        document.addEventListener("visibilitychange", function () {
            if (document.hidden) {
                localStorage.setItem("hideTime", (new Date().getTime()) / 1000)
            } else {
                let then = localStorage.getItem("hideTime")
                if (!!then) {
                    let now = (new Date().getTime()) / 1000
                    if (parseInt(now - then) > (3600 * 4)) {
                        authUtil.logout();
                    } else {
                        if (!!this.props.subscriptions && this.props.subscriptions.user_room.indexOf(userData.sub) === -1) {
                            socket.emit('user_room', userData.sub)
                            this.props.subscribe('user_room', userData.sub)
                            // Sentry.captureMessage(' Socket Connected :- ' + userData.sub )
                        }
                        // window.location.reload()
                    }
                    localStorage.removeItem("hideTime")
                }
            }
        });
        let accData = JSON.parse(localStorage.getItem("accountData"))
        if (!!accData && accData.username) {
            this.setState({ accountData: accData })
        }
        } else {
            this.setState({ loader: false })
        }
    }

    clean(obj) {
        for (var propName in obj) {
            if (obj[propName] === undefined) {
                delete obj[propName];
            }
        }
        return obj
    }

    getDeviceType() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "TABLET";
        }
        if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "MOBILE";
        }
        return "DESKTOP";
    };

    onCasinoFull(isCasinoFull) {
        this.setState({ isCasinoFull: isCasinoFull })
    }

    componentWillUnmount() {
        if (!!this.props.socket) {
            this.props.socket.off("user_room");
            this.props.socket.off("site_room");
        }
        document.getElementsByTagName('html')[0].classList.remove('iframe-container-page')
    }

    render() {
        const profData = JSON.parse(localStorage.getItem("profData"));
        return (
            <>
                <body className="radheexch">
                    <div className="fullscreen_logo">
                        {/* <a className="logo" href="/home"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/brand_logo.svg"} width="195" height="60px" className="mainlogo" /></a> */}
                    </div>
                    {!this.state.isCasinoFull && <Header notify={this.props.notify} subscribe={(type, id) => { this.props.subscribe(type, id) }} isEnglishCasino={false} isCasinoFull={this.state.isCasinoFull} onCasinoFull={() => { this.onCasinoFull(!this.state.isCasinoFull) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} />}
                    <div className={!this.state.isCasinoFull ? "full-wrap mar-top100 footerpd" : ""}>
                        {!this.state.isCasinoFull && <Menu history={this.props.history} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} />}
                        <div className={!this.state.isCasinoFull ? "col-center1 markets" : ""}>
                            {/* {this.state.isCasinoFull &&
                        <section>
                            <div className="sub_path center-box"><p></p>
                                <div className={this.state.isCasinoFull ? "text-center down-icon" : "text-center up-icon"} onClick={() => { this.onCasinoFull( !this.state.isCasinoFull ) }}>
                                    <img alt="" className="top--45" src={BASE_IMAGE_PATH + "/admin/images/next.svg"}></img>
                                </div>
                            </div>
                        </section>
                    } */}
                            {/* <section className={false ? "toggle-header master-balance-detail mt-0 market-p-fixed" : "toggle-header master-balance-detail mt-0"}>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className={true ? "text-center down-icon" : "text-center up-icon"} onClick={() => { this.setState({ userMenuHide: !this.state.userMenuHide }) }}>
                                            <img alt="" src={BASE_IMAGE_PATH + "/admin/images/next.svg"}></img>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section> */}
                            {this.state.loader &&
                                <div className="cgloading loading08">
                                    <span data-text="C">C</span>
                                    <span data-text="L">L</span>
                                    <span data-text="U">U</span>
                                    <span data-text="B">B</span>
                                    <span data-text="G">G</span>
                                    <span data-text="A">A</span>
                                    <span data-text="M">M</span>
                                    <span data-text="E">E</span>
                                    <span data-text="S">S</span>
                                </div>
                            }
                            {(!!profData && profData.role !== 'DemoClient') && this.state.url !== "" ? 
                            <div className={this.state.loader ? "d-none" : "d-block"}>
                                <iframe title={"Club Games"} key={"iframe"} style={{ width: "100%", height: "100vh", border: "0px", overflow: "hidden" }} src={this.state.url} scrolling={this.state.isCasinoFull ? "no" : "yes"} allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
                            </div>
                            :
                            <div className='text-blue'>
                                Login with Real Id.
                                <a className='ml-2 text-black-50 undline' href={window.origin}>click here to go back</a>
                            </div>
                            }
                        </div>
                    </div>
                    {/* <div className="fullscreen_button" onClick={() => { this.onCasinoFull( !this.state.isCasinoFull ) }}>
                        <i className={this.state.isCasinoFull ? "fa fa-compress fullscreen" : "fa fa-expand fullscreen"}></i>
                </div> */}

                </body>
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(RealGames);